<!-- 预售车 -->
<template>
  <cc-container>
    <skeleton v-show="showSkeleton"/>
    <cc-main style="overflow:hidden" v-show="!showSkeleton">
      <cc-pull-refresh :disabled="disabled" class="van-pull-refresh" v-model="isLoading" @refresh="onRefresh" style="height:100%">
        <cc-container style="height:100%">
          <cc-header-nav title="预售支付">
            <template slot="left">
              <cc-svg-icon
                @click="goBack"
                icon-class="left-arrow"
                class-name="left-arrow"
                size=".2rem"
              ></cc-svg-icon>
            </template>
          </cc-header-nav>
          <cc-main class="wrap" ref="wrapScroll">
            <div class="wrap-bg"  v-if="cartData && cartData.data.length !== 0"></div>
            <base-common
              v-show="cartData && cartData.data.length !== 0"
              @getCartInfo="getCartInfo"
              ref="baseRef"
              :coupon="coupon"/>
            <no-goods msg="亲，预售采购车空空如也~" v-if="(cartData && cartData.data.length === 0) || !cartData"/>
            <div class="wrap-list" v-else-if="cartData">
              <div class="wrap-list-group" v-for="(cartValue,cartKey,index) in cartData.data" :key="index">
                <div
                  class="presell"
                  v-for="(itemValue,itemKey,i) in cartValue.goods_list"
                  :key="i"
                >
                  <goods-item
                    :key="k"
                    class="presell-item"
                    v-for="(goods,k) in itemValue"
                    @updateGoods="postUpdateGoods"
                    :disabledClick="disabledClick"
                    @loadCartData="loadCartData"
                    :item="goods"/>
                  <div class="presell-price">
                    <span class="left">阶段1：定金</span>
                    <span class="right">￥{{cartValue.goods_list[8][0]['deposit']}}</span>
                  </div>
                  <div class="presell-price" v-if="+cartValue.goods_list[8][0]['payment_type'] !== 0">
                    <span class="left">阶段2：尾款</span>
                    <span class="right">￥{{cartValue.goods_list[8][0]['last_amout']}}</span>
                  </div>
                  <div class="presell-bottom" v-if="cartInfo && +cartInfo.presell_message_set === 1 && +cartValue.goods_list[8][0].payment_type !== 0">
                    <span class="left">尾款通知手机号</span>
                    <span
                      class="right"
                      @click="isEditTelPopup=true"
                      >
                      {{cartInfo && cartInfo.mobile}}
                      <cc-svg-icon class-name="ml5" icon-class="edit"></cc-svg-icon>
                      </span>
                  </div>
                </div>
              </div>
            </div>
          </cc-main>
        </cc-container>
      </cc-pull-refresh>
    </cc-main>
    <!-- //tabber 预售订单 -->
    <div class="submit-bar" v-if="cartData && cartData.data.length !== 0 && !showSkeleton">
      <div class="submit-info">
        <p class="total">定金支付：<i class="price">￥{{cartData.money}}</i></p>
      </div>
      <div class="submit-btn" @click="submitCart">支付定金</div>
    </div>
    <!-- //tabber -->
    <!-- 修改手机号码弹窗 -->
    <cc-bottom-popup
      :isShowPopup="isEditTelPopup"
      :height="556"
      :autoHeight="true"
      @close="isEditTelPopup = false"
      @subBtn="comfirmEditMobile"
      title="修改手机号"
      >
      <div class="edit-tel-popup">
        <p>尾款通知手机号</p>
        <input type="number" v-model="enterMobile" class="">
      </div>
    </cc-bottom-popup>
    <!-- 失效商品弹窗 -->
    <error-goods-popup
      :errorData="errorData"
      @loadData="loadCartData"
      v-model="isFailureGoodsPopup"
    />
  </cc-container>
</template>
<script>
import BaseCommon from './base-common'
import ErrorGoodsPopup from './error-goods-popup'

import Skeleton from './skeleton'
import CartMixin from '@/mixins/cart'
import GoodsItem from './item'
import NoGoods from './no-goods'
import { mapActions } from 'vuex'

export default {
  name: 'presell-cart',
  components: {
    BaseCommon,
    Skeleton,
    GoodsItem,
    NoGoods,
    ErrorGoodsPopup
  },
  mixins: [CartMixin],
  props: {},
  data () {
    return {
      isFirst: true,
      disabledClick: false,
      isEditTelPopup: false,
      cartInfo: null, // 购物车头部基础信息
      fromPath: '',
      enterMobile: '',
      isFailureGoodsPopup: false, // 失效商品
      isPresellPopup: false // 预售说明弹窗

    }
  },
  activated () {
    this.loadCartData()
  },
  computed: {},

  watch: {},

  created () {
  },

  methods: {
    ...mapActions(['SELECT_IDENTS']),
    comfirmEditMobile () {
      this.cartInfo.mobile = this.enterMobile
      this.isEditTelPopup = false
    },
    getCartInfo (msg) {
      this.cartInfo = msg
    },
    goBack () {
      this.isFirst = true
      this.SELECT_IDENTS({ ident: [], isSelect: true })
      this.$router.back()
    }
  }
}

</script>
<style lang='scss' scoped>
.wrap{
  &-bg{
    position: absolute;
    width: 100%;
    height: 20px;
    top: 0;
    left: 0;
    z-index: 5;
    background: linear-gradient(to right,var(--APP_theme_color) , var(--APP_theme_color_colorOpacity5));
  }
  &-list{
    &-item{
      min-height: 110px;
      width: 100%;
      box-sizing: border-box;
      padding: 15px 10px 0;
    }
    &-group{
      border-radius:10px;
      margin-bottom: 5px;
      background:rgba(255,255,255,1);
    }
  }

}
/* 修改手机号码 */
.edit-tel-popup{
  padding: 10px;
  p{
    color: #333333;
    font-size: 12px;
  }
  input{
    outline: none;
    border: none;
    width: 100%;
    height: 40px;
    margin-top: 15px;
    background:rgba(247,246,246,1);
    border-radius:4px;
    box-sizing: border-box;
    padding: 3px;
  }
}
.submit-bar{
  height: 50px;
  width: 100%;
  background:rgba(255,255,255,1);
  box-shadow:0px 1px 0px 0px rgba(224,224,224,0.47);
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  .edit-price-btn{
    display: inline-block;
    vertical-align: middle;
    line-height: 0.2rem;
    margin-left: 3px;
  }
  .submit-btn{
    width: 90px;
    height: 35px;
    background: var(--APP_theme_color);
    border-radius: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 15px;
  }
  .submit-info{
    flex:1 1;
    text-align: right;
    margin-right: 10px;
    .total{
      font-size: 12px;
      .price{
        font-weight:bold;
      }
    }
    .sale{
      font-size: 10px;
      b{
        color: #F73939;
        margin-left: 10px;
      }
    }
  }
  &-compile{
    display: flex;
    justify-content: space-between;
    .btns{
      display: flex;
    }
    .btn{
      width: 60px;
      height: 30px;
      border: 1px solid rgba(184,183,183,1);
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666666;
      font-size: 14px;
      margin-left: 15px;
    }
  }
}
/**预售 */
.presell{
  &-price{
    display: flex;
    padding: 10px 10px;
    justify-content: space-between;
    color: #333333;
    font-size: 12px;
    .right{
      font-weight: 600;
    }
  }
  &-bottom{
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e5e5e5;
    padding: 0 10px;
    color: #333333;
    font-size: 12px;
    .right{
      display: inline-flex;
      align-items: center;
    }
  }
  /deep/{
    .goods-info{
      border-bottom: none;
    }
  }
}
</style>
